export default (function (_a) {
    var disabled = _a.disabled;
    return "\n  pointer-events: " + (disabled ? "none" : "auto") + ";\n  cursor: " + (disabled ? "default" : "pointer") + ";\n";
});
